import { CountryCode } from "@domain/currentProfile/countryCode";
import { Organization } from "@domain/organization/organization";
import { OrganizationType } from "@domain/organization/organizationType";

type ExperienceOrganization = Omit<Organization, "id" | "type"> & {
	id?: string;
	type?: OrganizationType;
};
export interface Experience {
	id: string;
	organization: ExperienceOrganization;
	type: ExperienceType;
	title: string;
	countryCode?: CountryCode;
	start: Date;
	end?: Date;

	// Academic
	asTeacher?: boolean;
	diploma?: string;
	domain?: string;
}

export enum ExperienceType {
	ACADEMIC = "ACADEMIC",
	PROFESSIONAL = "PROFESSIONAL",
}
